import { render, staticRenderFns } from "./CreateForm.vue?vue&type=template&id=523ec824&scoped=true"
import script from "./CreateForm.vue?vue&type=script&lang=ts"
export * from "./CreateForm.vue?vue&type=script&lang=ts"
import style0 from "./CreateForm.vue?vue&type=style&index=0&id=523ec824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523ec824",
  null
  
)

export default component.exports